function _s(o, i, p, l) {
  void 0 === i && (i = 400),
    void 0 === l && (l = !1),
    (o.style.overflow = "hidden"),
    l && (o.style.display = "block");
  var n,
    t = window.getComputedStyle(o),
    s = parseFloat(t.getPropertyValue("height")),
    a = parseFloat(t.getPropertyValue("padding-top")),
    r = parseFloat(t.getPropertyValue("padding-bottom")),
    y = parseFloat(t.getPropertyValue("margin-top")),
    d = parseFloat(t.getPropertyValue("margin-bottom")),
    g = s / i,
    m = a / i,
    h = r / i,
    u = y / i,
    x = d / i;
  window.requestAnimationFrame(function t(e) {
    void 0 === n && (n = e);
    e -= n;
    l
      ? ((o.style.height = g * e + "px"),
        (o.style.paddingTop = m * e + "px"),
        (o.style.paddingBottom = h * e + "px"),
        (o.style.marginTop = u * e + "px"),
        (o.style.marginBottom = x * e + "px"))
      : ((o.style.height = s - g * e + "px"),
        (o.style.paddingTop = a - m * e + "px"),
        (o.style.paddingBottom = r - h * e + "px"),
        (o.style.marginTop = y - u * e + "px"),
        (o.style.marginBottom = d - x * e + "px")),
      i <= e
        ? ((o.style.height = ""),
          (o.style.paddingTop = ""),
          (o.style.paddingBottom = ""),
          (o.style.marginTop = ""),
          (o.style.marginBottom = ""),
          (o.style.overflow = ""),
          l || (o.style.display = "none"),
          "function" == typeof p && p())
        : window.requestAnimationFrame(t);
  });
}
(HTMLElement.prototype.slideToggle = function (t, e) {
  0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e);
}),
  (HTMLElement.prototype.slideUp = function (t, e) {
    _s(this, t, e);
  }),
  (HTMLElement.prototype.slideDown = function (t, e) {
    _s(this, t, e, !0);
  });

class ProductTemplate extends HTMLElement {
  constructor() {
    super();

    document.querySelector(".navigation-vrac ")?.classList.add("active");
    this.querySelector("[data-switsh-handle]")
      ? this.querySelector("[data-switsh-handle]").addEventListener(
          "click",
          this.changePage.bind(this)
        )
      : null;
    this.initBar();
    this.calculateShipping();
    this.querySelector(".product-tabs") ? this.initTabs() : null;
    this.querySelector(".swiper-review") ? this.initReviews() : null;
    this.querySelector(".product-form__upsells") ? this.initUpsell() : null;

    this.querySelector(
      ".custom_form_input [data-add-to-cart-text]:not([disabled])"
    )
      ? this.querySelector(
          ".custom_form_input [data-add-to-cart-text]:not([disabled])"
        ).addEventListener("click", this.addToCartSub.bind(this))
      : null;

    document
      .querySelector('.navigation-vrac__content [name="add"]')
      ?.addEventListener("click", (e) => {
        e.preventDefault();
        this.querySelector('.product-info__add-button [name="add"]').click();
      });

    if (this.querySelector(".product-option__container")) {
      document
        .querySelector(".product-option__container select")
        .addEventListener("change", function (e) {
          // set selected attribute to the selected option and delete it from the others

          document
            .querySelectorAll(".product-option__container option")
            .forEach((option) => {
              option.removeAttribute("selected");
            });

          document
            .querySelector(".product-option__container option:checked")
            .setAttribute("selected", "selected");
        });

      this.initOptionProduct();
    }

    window.addEventListener("load", function () {
      document
        .querySelector("#judgeme_product_reviews")
        ?.classList.add("section-navigation");
      document
        .querySelectorAll(".navigation-vrac__content [data-handle]")
        .forEach((anchor) => {
          anchor.addEventListener("click", function (e) {
            e.preventDefault();
            let item = anchor.getAttribute("data-handle");

            console.log(
              document.querySelector(`#${item}`).getBoundingClientRect().top
            );
            let scrollTop =
              document.querySelector(`#${item}`).getBoundingClientRect().top -
              document.body.getBoundingClientRect().top -
              116;

            window.scrollTo({ top: scrollTop, left: 0, behavior: "smooth" });
          });
        });
    });

    this.querySelector(".link-reviews__custom")
      ? this.querySelector(".link-reviews__custom").addEventListener(
          "click",
          this.scrollToReviews.bind(this)
        )
      : null;

    if (document.querySelector(".navigation-vrac")) {
      window.addEventListener("scroll", this.showOverlay.bind(this));
    }

    this.querySelector(".swiper-ingredientss")
      ? this.initIngredientsSlider()
      : null;

    this.querySelector(".product-form__slider_form")
      ? this.initReaSlider()
      : null;

    document.addEventListener("DOMContentLoaded", function () {
      document.querySelectorAll(".description-title").forEach(function (item) {
        item.addEventListener("click", function () {
          document
            .querySelectorAll(".description-title")
            .forEach(function (item) {
              item.classList.remove("acitve");
            });
          document
            .querySelectorAll(
              '.description-title[data-handle="' + item.dataset.handle + '"]'
            )
            .forEach(function (item) {
              item.classList.add("acitve");
            });
          document
            .querySelectorAll(".description-text")
            .forEach(function (item) {
              item.classList.add("hidden");
            });
          document
            .querySelectorAll(
              '.description-text[data-handle="' + item.dataset.handle + '"]'
            )
            .forEach(function (item) {
              item.classList.remove("hidden");
            });
        });
      });
    });

    window.addEventListener("load", function () {
      if (document.querySelector(".navigation-vrac__mobile")) {
        document
          .querySelector(".navigation-vrac__mobile")
          .addEventListener("change", function (e) {
            let item = e.target.value;
            let scrollTop =
              document.querySelector(`#${item}`).getBoundingClientRect().top -
              document.body.getBoundingClientRect().top -
              116;

            window.scrollTo({ top: scrollTop, left: 0, behavior: "smooth" });
          });
      }
    });
  }

  initReviews() {
    if (document.querySelector(".swiper-review").dataset.swiperDelay != 0) {
      let swiperDelay =
        document.querySelector(".swiper-review").dataset.swiperDelay;
      const swiper = new Swiper(this.querySelector(".swiper-review"), {
        slidesPerView: 1,
        autoplay: {
          delay: Number(swiperDelay),
        },
        navigation: {
          nextEl: this.querySelector(".swiper-review .swiper-button-next"),
          prevEl: this.querySelector(".swiper-review .swiper-button-prev"),
        },
      });
    } else {
      const swiper = new Swiper(this.querySelector(".swiper-review"), {
        slidesPerView: 1,
        navigation: {
          nextEl: this.querySelector(".swiper-review .swiper-button-next"),
          prevEl: this.querySelector(".swiper-review .swiper-button-prev"),
        },
      });
    }
  }

  initBar() {
    if (document.querySelector('[data-section-type="w-product-template-v2"]')) {
      document
        .querySelectorAll(".section_to_navigate:not(.hidden)")
        .forEach((section) => {
          let sectionId = section.getAttribute("id");
          // create <p data-handle="{{ id }}"><span class="dot"></span>{{ id}} </p >
          let p = document.createElement("p");
          p.setAttribute("data-handle", sectionId);
          p.innerHTML = `<span class="dot"></span>${sectionId}`;
          document.querySelector(".navigation-vrac__desk-js").appendChild(p);
        });
    }

    document.querySelectorAll(".navigation-vrac__desk p").forEach((p) => {
      p.addEventListener("click", function () {
        let sectionId = p.getAttribute("data-handle");
        let section = document.querySelector(`#${sectionId}`);
        let scrollTop =
          document.querySelector(`#${sectionId}`).getBoundingClientRect().top -
          document.body.getBoundingClientRect().top -
          116;

        window.scrollTo({ top: scrollTop, left: 0, behavior: "smooth" });
      });
    });

    window.addEventListener("scroll", function () {
      document.querySelectorAll(".section-navigation").forEach((section) => {
        section.classList.remove("your-active-class");
      });
      document.querySelectorAll(".section-navigation").forEach((section) => {
        //  if section is in the viewport

        if (
          section.getBoundingClientRect().top < 400 &&
          section.getBoundingClientRect().top > 100
        ) {
          section.classList.add("your-active-class");
          let id = document
            .querySelector(".your-active-class")
            .getAttribute("id");
          document
            .querySelectorAll(`.navigation-vrac__desk [data-handle]`)
            .forEach((elem) => {
              elem.classList.remove("button--active");
            });
          document
            .querySelector(`.navigation-vrac__desk [data-handle="${id}"]`)
            .classList.add("button--active");
        }
      });
    });
  }

  changePage(e) {
    let handle = e.currentTarget.dataset.switshHandle;

    // fetch product and replace page content with new content
    e.currentTarget.classList.add("loading");

    let url = window.location.origin;

    fetch(url + "/products/" + e.currentTarget.dataset.switshHandle)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        data = data.split('main id="main-content"')[1].split("</main>")[0];
        console.log("Success:", data);
        document.querySelector("main").innerHTML = data;

        //  change page url

        window.history.pushState(
          { path: url + "/products/" + handle },
          "",
          url + "/products/" + handle
        );
        this.querySelectorAll(".faq-item-title").forEach((button) => {
          button.addEventListener("click", this.toggleFaqItem.bind(this));
        });
        // document.querySelector('.product-template').dispatchEvent(new Event('change'));
        document
          .querySelectorAll(".description-title")
          .forEach(function (item) {
            item.addEventListener("click", function () {
              document
                .querySelectorAll(".description-title")
                .forEach(function (item) {
                  item.classList.remove("acitve");
                });
              document
                .querySelectorAll(
                  '.description-title[data-handle="' +
                    item.dataset.handle +
                    '"]'
                )
                .forEach(function (item) {
                  item.classList.add("acitve");
                });
              document
                .querySelectorAll(".description-text")
                .forEach(function (item) {
                  item.classList.add("hidden");
                });
              document
                .querySelectorAll(
                  '.description-text[data-handle="' + item.dataset.handle + '"]'
                )
                .forEach(function (item) {
                  item.classList.remove("hidden");
                });
            });
          });

        initJdgm();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  addToCartSub() {
    // for variant-item in dom , add items variant-item in items array
    let selections_items = [];

    let items = document.querySelectorAll("product-item");
    for (const item of items) {
      console.log(item);
      let quantity = item.querySelector(".quantity-input input").value;
      let id = item.dataset.variantId;
      if (document.querySelector('[data-subscribe="true"].actif')) {
        if (quantity > 0) {
          selections_items.push({
            id: Number(id),
            quantity: Number(quantity),
            selling_plan: Number(
              document.querySelector(".selling__inputs input:checked").value
            ),
          });
        }
      } else {
        if (quantity > 0) {
          selections_items.push({
            id: Number(id),
            quantity: Number(quantity),
          });
        }
      }
    }

    const data = {
      items: selections_items,
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Success:", data);
        // document.querySelector('.cart-icon-bubble').innerHTML = data.item_count;
        document.querySelector("side-cart").refreshCartAndOpen();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  scrollToReviews(event) {
    event.preventDefault();
    //  search #judgeme_product_reviews position and scroll to it smoothly with 150px offset

    const reviews = document.querySelector("#judgeme_product_reviews");
    const offset = 100;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = reviews.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }

  initOptionProduct() {
    document
      .querySelector(".product-option__container .btn")
      .addEventListener("click", function () {
        document
          .querySelector(".product-option__container")
          .classList.add("actif");
        document
          .querySelector(".product-option__container select")
          .dispatchEvent(new Event("change"));
        document.querySelector(
          ".product-option__container .label-active [data-option-product-name]"
        ).textContent = document.querySelector(
          ".product-option__container option:checked"
        ).dataset.optionProductName;
        let currentPrice = "";
        if (
          !document.querySelector(".product-info__add-button button[disabled]")
        ) {
          if (
            document.querySelector(
              ".product-info__add-button button .price__default"
            )
          ) {
            currentPrice = document.querySelector(
              ".product-info__add-button button .money"
            ).textContent;
            console.log(currentPrice);
          } else {
            currentPrice = document.querySelector(
              ".product-info__add-button button"
            ).textContent;
          }
          currentPrice = currentPrice.split("€")[1];
          currentPrice = Number(currentPrice);
          let productPrice =
            Number(
              document.querySelector("[data-option-price]").dataset.optionPrice
            ) / 100;
          document.querySelector(
            ".product-info__add-button button"
          ).textContent = `Ajouter au panier €${Number(
            (Number(currentPrice) + productPrice).toFixed(2)
          ).toFixed(2)}`;
        }
      });

    document
      .querySelector(".product-option__container [data-delete-option]")
      .addEventListener("click", function () {
        document
          .querySelector(".product-option__container")
          .classList.remove("actif");
        let currentPrice = "";
        if (
          !document.querySelector(".product-info__add-button button[disabled]")
        ) {
          if (
            document.querySelector(
              ".product-info__add-button button .price__default"
            )
          ) {
            currentPrice = document.querySelector(
              ".product-info__add-button button .money"
            ).textContent;
            currentPrice = currentPrice.remove("€")[1];
          } else {
            currentPrice = document.querySelector(
              ".product-info__add-button button"
            ).textContent;
            currentPrice = currentPrice.split("€")[1];
          }
          currentPrice = Number(currentPrice);

          let productPrice =
            Number(
              document.querySelector("[data-option-price]").dataset.optionPrice
            ) / 100;
          document.querySelector(
            ".product-info__add-button button"
          ).textContent = `Ajouter au panier €${Number(
            Number(currentPrice - productPrice)
          ).toFixed(2)}`;
        }
      });

    document
      .querySelector(".product-option__container [data-modif-option]")
      .addEventListener("click", function () {
        document
          .querySelector(".product-option__container ")
          .classList.remove("actif");
        let currentPrice = "";
        if (
          !document.querySelector(".product-info__add-button button[disabled]")
        ) {
          if (
            document.querySelector(
              ".product-info__add-button button .price__default"
            )
          ) {
            currentPrice = document.querySelector(
              ".product-info__add-button button .money"
            ).textContent;
            currentPrice = currentPrice.remove("€");
          } else {
            currentPrice = document.querySelector(
              ".product-info__add-button button"
            ).textContent;
            currentPrice = currentPrice.split("€")[1];
          }
          currentPrice = Number(currentPrice).toFixed(2);
          let productPrice =
            Number(
              document.querySelector("[data-option-price]").dataset.optionPrice
            ) / 100;
          console.log(currentPrice, productPrice);
          document.querySelector(
            ".product-info__add-button button"
          ).textContent = `Ajouter au panier €${Number(
            Number(currentPrice - productPrice)
          ).toFixed(2)}`;
        }
      });
  }

  showOverlay() {
    //  if .product-form__button .product-info__add-to-cart in on the view screen hide navigation-vrac sinon show it

    let productForm = document.querySelector(
      ".product-form__button .product-info__add-to-cart"
    );
    let navigationVrac = document.querySelector(".navigation-vrac");

    if (productForm) {
      let productFormRect = productForm.getBoundingClientRect();

      if (
        productFormRect.top < window.innerHeight &&
        productFormRect.bottom >= 0
      ) {
        navigationVrac.classList.remove("active");
      } else {
        navigationVrac.classList.add("active");
      }
    }
  }

  initReaSlider() {
    const swiper = new Swiper(
      this.querySelector(
        ".product-form__slider_form.product-form__block .swiper"
      ),
      {
        // Optional parameters
        direction: "horizontal",
        loop: true,
        breakpoints: {
          0: {
            slidesPerView: 2,
            spaceBetween: 12,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 12,
          },
        },

        autoplay: {
          delay: Number(
            this.querySelector(".product-form__slider_form").dataset.duration
          ),
        },
        // If we need pagination
        pagination: {
          el: this.querySelector(
            ".product-form__slider_form.product-form__block .swiper-pagination"
          ),
        },
      }
    );
  }

  initIngredientsSlider() {
    const swiper = new Swiper(this.querySelector(".swiper-ingredientss"), {
      slidesPerView: 1,
      navigation: {
        nextEl: this.querySelector(".swiper-ingredientss .swiper-button-next"),
        prevEl: this.querySelector(".swiper-ingredientss .swiper-button-prev"),
      },
      pagination: {
        el: this.querySelector(".swiper-ingredientss .swiper-pagination-2"),
        clickable: true,
      },
    });
  }

  calculateShipping() {
    if (document.querySelector(".product-form__icon")) {
      let date = new Date();
      let hour = date.getHours();

      if (
        hour <=
        Number(document.querySelector(".jc-delivery-date").dataset.limitHour)
      ) {
        for (
          let i = 0;
          i < document.querySelectorAll(".product-form__icon").length;
          i++
        ) {
          let html = document.querySelectorAll(".product-form__icon")[i]
            .innerHTML;
          if (html.indexOf("[date]") > -1) {
            document.querySelectorAll(".product-form__icon")[i].innerHTML =
              html.replace("[date]", "aujourd'hui");
          }
        }
      } else {
        // calculate shipping date from today + shipping delay exclude weekends
        let shipping_date = new Date(new Date().getTime());

        let shipping_delay = 1;
        for (var i = 0; i < shipping_delay; i++) {
          shipping_date.setDate(shipping_date.getDate() + 1);
          if (shipping_date.getDay() == 6) {
            shipping_date.setDate(shipping_date.getDate() + 2);
          }
          if (shipping_date.getDay() == 0) {
            shipping_date.setDate(shipping_date.getDate() + 1);
          }
        }

        // get french date format day month year
        let shipping_date_format = shipping_date.toLocaleDateString("fr-FR", {
          day: "numeric",
          month: "long",
          year: "numeric",
        });

        for (
          let i = 0;
          i < document.querySelectorAll(".product-form__icon").length;
          i++
        ) {
          let html = document.querySelectorAll(".product-form__icon")[i]
            .innerHTML;
          if (html.indexOf("[date]") > -1) {
            document.querySelectorAll(".product-form__icon")[i].innerHTML =
              html.replace("[date]", `le ${shipping_date_format}`);
          }
        }
      }

      document.querySelectorAll(".jc-delivery-date").forEach((icon) => {
        icon.classList.remove("hide_message");
      });
    }
  }

  initTabs() {
    const tabsRoot = this.querySelector("[data-product-tabs]") || this.querySelector(".product-tabs");
    if (!tabsRoot) return;

    if (!tabsRoot.dataset.tabsBound) {
      tabsRoot.addEventListener("click", (e) => {
        const title = e.target.closest(".tabs-section__item-title");
        if (!title || !tabsRoot.contains(title)) return;
        this.toggleFaqItem({ currentTarget: title });
      });
      tabsRoot.dataset.tabsBound = "true";
    }

    const dataEl = this.querySelector(".product-tabs__data");
    if (dataEl) {
      try {
        this.productTabsData = JSON.parse(dataEl.textContent || "{}");
      } catch (err) {
        this.productTabsData = null;
      }
      const iconTemplate = this.querySelector(".product-tabs__icon-template");
      this.productTabsIconHtml = iconTemplate ? iconTemplate.innerHTML.trim() : "";

      if (!this._productTabsVariantBound) {
        this.addEventListener("on:variant:change", (event) => {
          this.updateProductTabs(event.detail?.variant?.id);
        });
        this._productTabsVariantBound = true;
      }

      const selectedId =
        this.querySelector('input[name="id"]')?.value ||
        this.productTabsData?.selectedVariantId;
      this.updateProductTabs(selectedId);
    }
  }

  mergeProductTabs(productTabs, variantTabs) {
    const productList = Array.isArray(productTabs) ? productTabs : [];
    const variantList = Array.isArray(variantTabs) ? variantTabs : [];
    let merged = productList.map((tab, index) => ({
      tab,
      rank: index + 1,
      source: "product",
    }));

    for (const vtab of variantList) {
      if (vtab == null || vtab.rank === null || vtab.rank === undefined || vtab.rank === "") {
        continue;
      }
      const numericRank = Number(vtab.rank);
      if (Number.isNaN(numericRank)) continue;

      const mode = String(vtab.mode || "insert").toLowerCase();
      if (mode === "replace") {
        const target = Math.floor(numericRank);
        merged = merged.filter(
          (entry) => !(entry.source === "product" && entry.rank === target)
        );
      }
      merged.push({ tab: vtab, rank: numericRank, source: "variant" });
    }

    merged.sort((a, b) => {
      if (a.rank !== b.rank) return a.rank - b.rank;
      if (a.source === b.source) return 0;
      return a.source === "product" ? -1 : 1;
    });

    return merged.map((entry) => entry.tab);
  }

  escapeProductTabTitle(title) {
    return String(title || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  renderProductTabs(tabs) {
    const tabsRoot = this.querySelector("[data-product-tabs]") || this.querySelector(".product-tabs");
    if (!tabsRoot) return;

    if (!tabs.length) {
      tabsRoot.innerHTML = "";
      tabsRoot.hidden = true;
      return;
    }

    tabsRoot.hidden = false;
    const iconHtml = this.productTabsIconHtml || "";
    tabsRoot.innerHTML = tabs
      .map((tab) => {
        const isOpen = !!tab.defaultOpen;
        return `<div class="tabs-section__item${isOpen ? " faq-item-active" : ""}">
        <div class="tabs-section__item-title faq-item-title">
          ${this.escapeProductTabTitle(tab.title)}
          <div class="faq-close${isOpen ? " faq-display-none" : ""}">${iconHtml}</div>
        </div>
        <div class="tabs-section__text faq-item-text"${isOpen ? ' style="display:block"' : ""}>
          ${tab.textHtml || ""}
        </div>
      </div>`;
      })
      .join("");
  }

  resolveMergedTabs(variantId) {
    const productTabs = this.productTabsData?.productTabs || [];
    const variantTabsById = this.productTabsData?.variantTabsById || {};
    const variantTabs =
      variantId != null ? variantTabsById[String(variantId)] || [] : [];
    return this.mergeProductTabs(productTabs, variantTabs);
  }

  buildTabsSignature(tabs) {
    return (tabs || [])
      .map(
        (t) =>
          `${t.title}\u0001${t.defaultOpen ? 1 : 0}\u0001${t.textHtml || ""}`
      )
      .join("\u0002");
  }

  updateProductTabs(variantId) {
    if (!this.productTabsData) return;
    const tabs = this.resolveMergedTabs(variantId);
    const signature = this.buildTabsSignature(tabs);
    if (signature === this._lastTabsSignature) return;
    this._lastTabsSignature = signature;
    this.renderProductTabs(tabs);
  }

  initUpsell() {
    window.addEventListener("load", () => {
      this.querySelectorAll(
        ".product-form__complementary .product-form__uppsel-add-to-cart"
      ).forEach((button) => {
        button.addEventListener("click", this.addToCart.bind(this));
      });

      const swiper = new Swiper(
        this.querySelector(".product-form__upsells .swiper"),
        {
          // Optional parameters
          direction: "horizontal",
          loop: true,

          // If we need pagination
          pagination: {
            el: this.querySelector(".product-form__upsells .swiper-pagination"),
          },

          // Navigation arrows
          navigation: {
            nextEl: this.querySelector(
              ".product-form__upsells .swiper-button-next"
            ),
            prevEl: this.querySelector(
              ".product-form__upsells .swiper-button-prev"
            ),
          },

          // And if we need scrollbar
          scrollbar: {
            el: this.querySelector(".product-form__upsells .swiper-scrollbar"),
          },
        }
      );
    });
  }

  addToCart() {
    const id = this.querySelector(".product-form__uppsel-add-to-cart").dataset
      .id;
    const quantity = 1;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: id,
            quantity: quantity,
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Success:", data);
        document.querySelector(".cart-icon-bubble").innerHTML = data.item_count;
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  toggleFaqItem(e) {
    e.currentTarget
      .querySelector(".faq-close")
      .classList.toggle("faq-display-none");

    e.currentTarget.parentNode.classList.toggle("faq-item-active");

    const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
    console.log(item);

    item.slideToggle("250");
  }
}

customElements.define("product-template", ProductTemplate);

class ReccuringOption extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.selectOption.bind(this));

    // Initialize default checked state based on sub_active value
    // Only run this once on the first element to avoid duplicate initialization
    if (this === document.querySelector("recurring-option")) {
      this.initDefaultCheckedState();
    }

    if (this.dataset.subscribe === "true") {
      this.initEventSelectReccuring();
      this.initCurrentRecurringText();
    } else {
    }

    if (document.querySelector(".product-composer")) {
      window.addEventListener("load", () => {
        document.querySelector("product-item").uptadePrice();
      });
    }

    // check if click outside .product-pack__recurring-select-values and close it
    document.addEventListener("click", (event) => {
      if (event.target.closest(".product-pack__recurring-select") === null) {
        this.querySelector(".product-pack__recurring-select-values")
          ? this.querySelector(
              ".product-pack__recurring-select-values"
            ).classList.add("hidden")
          : null;
        this.querySelector(".product-pack__recurring-select")
          ? this.querySelector(
              ".product-pack__recurring-select"
            ).classList.remove("actif")
          : null;
      }
    });
  }

  initDefaultCheckedState() {
    // Get values from data attributes on the product form container
    const productForm = document.querySelector(".product-form-vrac");
    const showSubscriptionFirstAttr = productForm?.getAttribute(
      "data-show-subscription-first"
    );
    const subActiveAttr = productForm?.getAttribute("data-sub-active");

    // Check if subscriptions are hidden by admin setting
    const subscriptionOptionsHidden =
      document.querySelector(
        ".product-pack__recurring-options.hidden-force"
      ) !== null;

    // Check if we're in toggle mode (show_subscription_details = false)
    const isToggleMode =
      document.querySelector(
        ".product-pack__recurring-options.toggle-subscription"
      ) !== null;

    // Convert strings to booleans
    const showSubscriptionFirst = showSubscriptionFirstAttr === "true";
    const subActiveBoolean = subActiveAttr === "abo"; // 'abo' means subscriptions are enabled

    // Apply the business rule:
    let subActive;
    if (!subActiveBoolean || subscriptionOptionsHidden) {
      // Subscription is not active OR admin has hidden subscriptions → always select one-time purchase
      subActive = "one-shot";
    } else {
      // Subscription is active AND visible → check showSubscriptionFirst
      if (showSubscriptionFirst) {
        subActive = "abo";
      } else {
        subActive = "one-shot";
      }
    }

    // If we're in subscription mode, check the first subscription option
    if (subActive === "abo") {
      // Find and select the subscription option
      const subscriptionOption = document.querySelector(
        '[data-subscribe="true"]'
      );
      if (subscriptionOption) {
        // document.querySelectorAll(".selling__inputs input").forEach((input) => {
        //   input.checked = false;
        // });

        // Set the appropriate subscription selling plan as checked
        const recurringSelectActif = document.querySelector(
          ".product-pack__recurring-select-values .actif"
        );
        const firstSellingPlan = document.querySelector(
          ".selling__inputs .first"
        );

        if (recurringSelectActif) {
          const forAttribute = recurringSelectActif.getAttribute("for");
          // Try to find the input in both locations
          let targetInput = document.querySelector(
            `.selling__inputs #${forAttribute}`
          );
          if (!targetInput) {
            targetInput = document.querySelector(`#${forAttribute}`);
          }
          if (targetInput) {
            targetInput.checked = true;
          }
        } else if (firstSellingPlan) {
          firstSellingPlan.checked = true;
        }

        // Add the actif class to the subscription option
        subscriptionOption.classList.add("actif");
        document
          .querySelector('[data-subscribe="false"]')
          ?.classList.remove("actif");

        // Show subscription content if needed
        if (document.querySelector(".sub-content")) {
          document.querySelector(".sub-content").classList.add("active");
          // In toggle mode, ensure details are visible when subscription is selected
          if (isToggleMode) {
            document.querySelector(".sub-content").style.display = "block";
          }
        }
      }
    } else {
      // If one-shot mode, check the one-time purchase option
      const onetimeOption = document.querySelector('[data-subscribe="false"]');
      if (onetimeOption) {
        document.querySelectorAll(".selling__inputs input").forEach((input) => {
          input.checked = false;
        });

        // Set the one-time purchase option as checked
        if (document.querySelector(".no-abo-ok")) {
          const noAboInput = document.querySelector(".no-abo-ok");
          noAboInput.checked = true;
        }

        // Add the actif class to the one-time option
        onetimeOption.classList.add("actif");
        document
          .querySelector('[data-subscribe="true"]')
          ?.classList.remove("actif");

        // Hide subscription content if needed
        if (document.querySelector(".sub-content")) {
          document.querySelector(".sub-content").classList.remove("active");
          // In toggle mode, ensure details are hidden when one-time is selected
          if (isToggleMode) {
            document.querySelector(".sub-content").style.display = "none";
          }
        }
      }
    }
  }

  initEventSelectReccuring() {
    this.querySelectorAll(
      ".product-pack__recurring-current, .product-pack__recurring-select svg"
    ).forEach((select) => {
      select.addEventListener("click", (event) => {
        event.preventDefault();
        this.querySelector(
          ".product-pack__recurring-select-values"
        ).classList.toggle("hidden");
        this.querySelector(".product-pack__recurring-select").classList.toggle(
          "actif"
        );
      });
    });

    this.querySelectorAll(
      ".product-pack__recurring-select-values label"
    ).forEach((select) => {
      select.addEventListener("click", (event) => {
        event.preventDefault();
        this.querySelector(
          ".product-pack__recurring-current"
        ).innerHTML = `<span class="product-pack__recurring-current-value" data-selling-plan-id="${event.currentTarget
          .getAttribute("for")
          .replace("selling_plan_", "")}">${event.target.innerHTML}</span>`;
        this.querySelector(
          ".product-pack__recurring-select-values"
        ).classList.toggle("hidden");
        this.querySelector(".product-pack__recurring-select").classList.remove(
          "actif"
        );

        // Update the current_recuring span text by removing the first word "Livraison"
        const selectedText = event.target.innerHTML;
        const recurringText = selectedText.replace(/^Livraison\s+/, "");
        const currentRecuringSpan = this.querySelector(".current_recuring");
        if (currentRecuringSpan) {
          currentRecuringSpan.textContent = recurringText;
        }

        // First, uncheck ALL selling plan inputs (both visual and hidden)
        document.querySelectorAll(".selling__inputs input").forEach((input) => {
          input.checked = false;
        });
        document
          .querySelectorAll(
            ".product-pack__recurring-select-values input, .selling__inputs input"
          )
          .forEach((input) => {
            input.checked = false;
          });

        document
          .querySelectorAll(".product-pack__recurring-select-values label")
          .forEach((label) => {
            label.classList.remove("actif");
          });

        // Then, set the selected option as active and checked
        event.currentTarget.classList.add("actif");
        const targetInputId = event.currentTarget.getAttribute("for");
        const clickedText = event.target.innerHTML;

        // Check the visual input (in product-pack__recurring-select-values)
        const visualInput = document.querySelectorAll(`#${targetInputId}`);
        if (visualInput) {
          visualInput.forEach((input) => {
            console.log(input);
            setTimeout(function () {
              input.checked = true;
            }, 300);
          });
        }
      });
    });
  }

  initCurrentRecurringText() {
    // Set the initial current_recuring text based on the active option
    const activeLabel = this.querySelector(
      ".product-pack__recurring-select-values .actif"
    );
    if (activeLabel) {
      const selectedText = activeLabel.textContent;
      const recurringText = selectedText.replace(/^Livraison\s+/, "");
      const currentRecuringSpan = this.querySelector(".current_recuring");
      if (currentRecuringSpan) {
        currentRecuringSpan.textContent = recurringText;
      }
    }
  }

  updatePriceCta() {
    const is_subscription = document.querySelector(
      '[data-subscribe="true"].actif'
    )
      ? true
      : false;
  }

  selectOption(event) {
    document.querySelectorAll("recurring-option").forEach((option) => {
      option.classList.remove("actif");
    });

    this.classList.add("actif");

    if (document.querySelector(".product-composer")) {
      document.querySelector("product-item").uptadePrice();
    }

    // Notify variant-picker to refresh prices (subscription vs one-time changed)
    this.dispatchEvent(
      new CustomEvent("recurring-option:change", {
        bubbles: true,
        detail: { subscribe: this.dataset.subscribe === "true" },
      })
    );

    // Check if we're in toggle mode (show_subscription_details = false)
    const isToggleMode =
      document.querySelector(
        ".product-pack__recurring-options.toggle-subscription"
      ) !== null;

    if (this.dataset.subscribe === "true") {
      const firstInput = document.querySelector(".selling__inputs .first");
      if (firstInput) {
        firstInput.checked = true;
      }
      if (
        !document.querySelector(".sub-content").classList.contains("active")
      ) {
        document.querySelector(".sub-content").classList.add("active");
        // Show subscription details when subscription is selected
        if (isToggleMode) {
          // In toggle mode, always show when subscription is selected
          document.querySelector(".sub-content").slideDown("250");
        } else if (!document.querySelector(".show-content-sub")) {
          // In block mode, only animate if not show-content-sub
          document.querySelector(".sub-content").slideDown("250");
        }
      }
      if (!document.querySelector(".hydratation-product")) {
        const variantPicker = this.closest(".js-product")?.querySelector("variant-picker") || document.querySelector("variant-picker");
        if (variantPicker && typeof variantPicker.handleVariantChange === "function") {
          variantPicker.handleVariantChange();
        }
      }
      document.querySelectorAll(".selling__inputs input").forEach((input) => {
        input.removeAttribute("checked");
      });
      const activeInput = document.querySelector(
        `#${document
          .querySelector(".product-pack__recurring-select-values .actif")
          .getAttribute("for")}`
      );
      if (activeInput) {
        activeInput.checked = true;
      }
      document.querySelector(".sub-content").classList.add("active");
    } else {
      // Hide subscription details when one-time purchase is selected
      if (isToggleMode) {
        // In toggle mode, always hide when one-time is selected
        document.querySelector(".sub-content").slideUp("250");
      } else if (!document.querySelector(".show-content-sub")) {
        // In block mode, only animate if not show-content-sub
        document.querySelector(".sub-content").slideUp("250");
      }
      document.querySelector(".sub-content").classList.remove("active");
      document.querySelectorAll(".selling__inputs input").forEach((input) => {
        input.removeAttribute("checked");
      });
      if (!document.querySelector(".hydratation-product")) {
        const variantPicker = this.closest(".js-product")?.querySelector("variant-picker") || document.querySelector("variant-picker");
        if (variantPicker && typeof variantPicker.handleVariantChange === "function") {
          variantPicker.handleVariantChange();
        }
      }
      const noAboInput = document.querySelector(".no-abo-ok");
      if (noAboInput) {
        noAboInput.checked = true;
      }
    }

    this.updatePriceCta();
  }
}

if (customElements.get("recurring-option") === undefined) {
  customElements.define("recurring-option", ReccuringOption);
}

let currentReduction = 0;

class ProductItem extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    this.quantityInput = this.querySelector(".quantity-input");
    this.quantityInput.addEventListener(
      "click",
      this.handleQuantity.bind(this)
    );
  }

  handleQuantity(e) {
    const action = e.target.getAttribute("data-action");
    const input = this.quantityInput.querySelector("input");
    const value = parseInt(input.value);

    if (action === "increment") {
      input.value = value + 1;
      this.classList.add("actif");
    } else if (action === "decrement" && value > 0) {
      input.value = value - 1;
      if (input.value == 0) {
        this.classList.remove("actif");
      }
    }

    this.uptadePrice();
  }

  uptadePrice() {
    // take all input value and calculate the total price
    const quantityInputs = document.querySelectorAll("quantity-input-v2 input");
    let totalPrice = 0;
    let totalQuantity = 0;
    let totalPrice_global = 0;

    const price = parseFloat(this.getAttribute("data-product-price"));

    quantityInputs.forEach((input) => {
      const quantity = parseInt(input.value);

      totalQuantity += quantity;
      totalPrice += quantity * price;
      totalPrice_global = totalPrice;
    });

    document.querySelector("[data-tubes]").textContent = totalQuantity;
    document.querySelector("[data-pastilles]").textContent = totalQuantity * 20;

    console.log(totalPrice, totalQuantity);

    if (
      totalQuantity <=
      parseInt(
        document.querySelector(
          ".product-form__progress--bar-item-1[data-reduction-step]"
        ).dataset.reductionStep
      )
    ) {
      let multiply =
        100 /
        Number(
          document.querySelector(
            ".product-form__progress--bar-item-1[data-reduction-step]"
          ).dataset.reductionStep
        );
      document.querySelector(
        ".product-form__progress--bar-item-1[data-reduction-step] .progress__fill .fill__content"
      ).style.width = `${multiply * totalQuantity}%`;
      document.querySelector(
        ".product-form__progress--bar-item-3[data-reduction-step] .progress__fill .fill__content"
      ).style.width = `0%`;
      if (
        totalQuantity ==
        Number(
          document.querySelector(
            ".product-form__progress--bar-item-1[data-reduction-step]"
          ).dataset.reductionStep
        )
      ) {
        document
          .querySelector(
            ".product-form__progress--bar-item-1[data-reduction-step]"
          )
          .classList.add("active");
      } else {
        document
          .querySelector(
            ".product-form__progress--bar-item-1[data-reduction-step] "
          )
          .classList.remove("active");
        currentReduction = 0;
      }
    }

    if (
      totalQuantity >
        parseInt(
          document.querySelector(
            ".product-form__progress--bar-item-3[data-reduction-step]"
          ).dataset.reductionStep
        ) &&
      totalQuantity <
        parseInt(
          document.querySelector(
            ".product-form__progress--bar-item-1[data-reduction-step]"
          ).dataset.reductionStep
        )
    ) {
      currentReduction = Number(
        document.querySelector(
          ".product-form__progress--bar-item-1[data-reduction-step]"
        ).dataset.reduction
      );
    }

    if (
      totalPrice >=
      parseInt(
        document.querySelector(
          ".product-form__progress--bar-item-2[data-reduction-step]"
        ).dataset.reductionStep
      ) *
        100
    ) {
      document.querySelector(
        ".product-form__progress--bar-item-2[data-reduction-step] .progress__fill .fill__content"
      ).style.width = `100%`;
      document
        .querySelector(
          ".product-form__progress--bar-item-2[data-reduction-step]"
        )
        .classList.add("active");
    } else {
      document.querySelector(
        ".product-form__progress--bar-item-2[data-reduction-step] .progress__fill .fill__content"
      ).style.width = `0%`;
      document
        .querySelector(
          ".product-form__progress--bar-item-2[data-reduction-step] "
        )
        .classList.remove("active");
    }

    if (
      totalQuantity ==
        parseInt(
          document.querySelector(
            ".product-form__progress--bar-item-1[data-reduction-step]"
          ).dataset.reductionStep
        ) ||
      (totalQuantity >=
        parseInt(
          document.querySelector(
            ".product-form__progress--bar-item-1[data-reduction-step]"
          ).dataset.reductionStep
        ) &&
        totalQuantity <=
          parseInt(
            document.querySelector(
              ".product-form__progress--bar-item-3[data-reduction-step]"
            ).dataset.reductionStep
          ))
    ) {
      let multiply =
        100 /
        (Number(
          document.querySelector(
            ".product-form__progress--bar-item-3[data-reduction-step]"
          ).dataset.reductionStep
        ) -
          Number(
            document.querySelector(
              ".product-form__progress--bar-item-1[data-reduction-step]"
            ).dataset.reductionStep
          ));
      document.querySelector(
        ".product-form__progress--bar-item-3[data-reduction-step] .progress__fill .fill__content"
      ).style.width = `${
        multiply *
        (totalQuantity -
          (Number(
            document.querySelector(
              ".product-form__progress--bar-item-3[data-reduction-step]"
            ).dataset.reductionStep
          ) -
            Number(
              document.querySelector(
                ".product-form__progress--bar-item-1[data-reduction-step]"
              ).dataset.reductionStep
            )))
      }%`;
      if (
        totalQuantity ==
        Number(
          document.querySelector(
            ".product-form__progress--bar-item-3[data-reduction-step]"
          ).dataset.reductionStep
        )
      ) {
        document
          .querySelector(
            ".product-form__progress--bar-item-3[data-reduction-step]"
          )
          .classList.add("active");
      } else {
        document
          .querySelector(
            ".product-form__progress--bar-item-3[data-reduction-step] "
          )
          .classList.remove("active");
        currentReduction = Number(
          document.querySelector(
            ".product-form__progress--bar-item-1[data-reduction-step]"
          ).dataset.reduction
        );
      }
    }

    if (
      totalQuantity >=
      parseInt(
        document.querySelector(
          ".product-form__progress--bar-item-3[data-reduction-step]"
        ).dataset.reductionStep
      )
    ) {
      currentReduction = Number(
        document.querySelector(
          ".product-form__progress--bar-item-3[data-reduction-step]"
        ).dataset.reduction
      );
    }

    let currentReductionNow = 15 / 100;
    let currentReductionSub = 10 / 100;
    currentReduction = currentReduction / 100;

    let totalReductionSub = totalPrice_global * currentReductionSub;
    let totalReduction = totalPrice * currentReduction;
    let totalReductionNow = totalPrice_global * currentReductionNow;

    let totalPriceSub = totalPrice_global - totalReductionSub;
    let totalPriceNow = totalPrice_global - totalReductionNow;

    totalPrice = totalPrice - totalReduction;

    if (currentReduction != 0) {
      if (document.querySelector('[data-subscribe="false"]')) {
        document.querySelector(
          '[data-subscribe="false"] .price__was '
        ).textContent = `${(totalPrice_global / 100).toFixed(2)}€`;
      }
    } else {
      if (document.querySelector('[data-subscribe="false"]')) {
        document.querySelector(
          '[data-subscribe="false"] .price__was '
        ).textContent = ``;
      }
    }

    if (
      document.querySelector('[data-subscribe="true"]') &&
      document.querySelector('[data-subscribe="false"]')
    ) {
      document.querySelector(
        '[data-subscribe="true"] .price__current.price__curent--offer .money'
      ).textContent = `${(totalPriceNow / 100).toFixed(2)}€`;
      document.querySelector(
        '[data-subscribe="true"] .price__current--custom:not(.price__curent--offer) .money'
      ).textContent = `${(totalPriceSub / 100).toFixed(2)}€`;
      document.querySelector(
        '[data-subscribe="false"] .price__current .money'
      ).textContent = `${(totalPrice / 100).toFixed(2)}€`;
      document.querySelector(
        '[data-subscribe="true"] .price__was .money'
      ).textContent = `${(totalPrice_global / 100).toFixed(2)}€`;
    }
    if (document.querySelector('[data-subscribe="true"].actif')) {
      document.querySelector(
        ".product-info__add-button .money"
      ).textContent = `${(
        (totalPrice - totalPrice * currentReductionNow) /
        100
      ).toFixed(2)}€`;
      document.querySelector(
        ".product-composer__bottom-button .money"
      ).textContent = `${(
        (totalPrice_global - totalPrice_global * currentReductionNow) /
        totalQuantity /
        100
      ).toFixed(2)}€`;
    } else {
      if (currentReduction != 0) {
        document.querySelector(
          ".product-composer__bottom-button .money"
        ).textContent = `€${((price - price * currentReduction) / 100).toFixed(
          2
        )}`;
        document.querySelector(
          ".navigation-vrac__content .product-info__add-button .money"
        ).textContent = `€${((price - price * currentReduction) / 100).toFixed(
          2
        )}`;
      } else {
        document.querySelector(
          ".product-composer__bottom-button .money"
        ).textContent = `€${(price / 100).toFixed(2)}`;
        document.querySelector(
          ".navigation-vrac__content .product-info__add-button .money"
        ).textContent = `€${(price / 100).toFixed(2)}`;
      }
      document.querySelector(
        ".product-info__add-button .money"
      ).textContent = `${(totalPrice / 100).toFixed(2)}€`;
      document.querySelector(
        ".navigation-vrac__content .product-info__add-button .money"
      ).textContent = `${(totalPrice / 100).toFixed(2)}€`;
    }

    if (document.querySelector('[data-subscribe="true"].actif')) {
      document.querySelector(
        ".product-info__add-button .money"
      ).textContent = `€${(totalPriceNow / 100).toFixed(2)}`;
    }

    if (totalQuantity == 0) {
      document
        .querySelector(".product-info__add-button [data-add-to-cart-text]")
        .setAttribute("disabled", "disabled");
    } else {
      document
        .querySelector(".product-info__add-button [data-add-to-cart-text]")
        .removeAttribute("disabled");
    }
  }
}

customElements.define("product-item", ProductItem);
